import { Stack, Grid, MenuItem } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledDateBox = styled.div`
  width: 100% !important;
  & div {
    z-index: 100000 !important;
  }
  & .rmdp-container {
    width: 100% !important;
  }
`;

export const StyledTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: gray;
`;

export const StyledGridBox = styled(Grid)`
  width: 100% !important;
`;

export const StyledContainerBox = styled.div`
  width: 100% !important;
  position: relative !important;
  & .MuiOutlinedInput-root label,
  & .MuiOutlinedInput-root div,
  & .MuiOutlinedInput-root input,
  & .MuiOutlinedInput-root fieldset {
    opacity: 0 !important;
  }
`;

export const StyledUploadBox = styled.div`
  width: 100% !important;
  height: 100% !important;
  color: ${(props) =>
    props.file ? (props.error ? "#d32f2f" : "black") : "rgba(0, 0, 0, 0.6)"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  border: 1px solid
    ${(props) => (props.error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)")};
  border-radius: 5px;
  padding: 5.1px 14px;
  & svg {
    color: ${theme.palette.primary.main};
    font-size: 24px;
    margin: 0px !important;
    padding: 0px !important;
  }
`;

export const StyledChoiceFileText = styled.span`
  max-width: 100% !important;
  color: #333 !important;
  font-size: 17px !important;
  margin: 0px !important;
  padding: 0px !important;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: 10px;
  text-align: left;
`;
export const StyledMenuItem = styled(MenuItem)`
  text-align: right !important;
  direction: rtl;
`;
